import React from 'react';
import { Form, TextArea as TextAreaInput, Label } from 'semantic-ui-react';
import { LabelForm } from '../../../styled/components/commons';

class CustomTextArea extends React.Component {

    render() {

        return (
            <Form.Field className={ this.props.fieldClasses } error={ this.props.meta.touched && this.props.meta.invalid }>
                <LabelForm>{ this.props.label }</LabelForm>
                <TextAreaInput
                    { ...this.props.input }
                    disabled={this.props.disabled || false}
                    placeholder={ this.props.placeholder }
                    onBlur={ e => this.props.input.onChange(e) }
                    onChange={ e => this.props.input.onChange(e) }
                    />
                { this.props.meta.touched && this.props.meta.invalid && <Label basic color={ this.props.colorLabel || 'red' } pointing>{ this.props.meta.error }</Label> }
            </Form.Field>
        );

    }

}

export default CustomTextArea;